let MaterialMap = {}
let TextureMap = {}
class UVAnimation {
  nodeTree
  nodeInfoList_m = []
  materialMap
  textureMap
  mixer
  player
  constructor(player) {
    this.player = player
    this.materialMap = MaterialMap
    this.textureMap = TextureMap
  }
  async init(node, baseData, nodeInfoList) {
    // 克隆节点
    const cloneNode = this.cloneNode = await this.player.Native.Node.clone(node)
    const info = await this.player.Native.Node.getProperty(node, ['name', 'code', 'parent'])
    await this.player.Native.Node.setProperty(cloneNode, { parent: info.parent })

    // 隐藏原节点
    this.OriginNode = node
    await this.player.Native.Node.setProperty(this.OriginNode, { visible: false })

    const flag = !!(nodeInfoList && nodeInfoList.length)
    const newNodeInfoList = []
    this.nodeTree = await this.traverseNode(cloneNode, (nodeInfo) => {
      nodeInfo.code = nodeInfo.code || nodeInfo.name // 防止code不存在，用name代替
      if (nodeInfo.material && nodeInfo.code) {
        let N
        const res = flag ? nodeInfoList.find(item => (item.code === nodeInfo.code)) : false
        if (res) {
          N = { ...res, ...nodeInfo }
          newNodeInfoList.push(N)
        } else {
          N = { ...nodeInfo, ...baseData, activate: !flag }
        }
        this.nodeInfoList_m.push(N)
      }
    }, ['name', 'code', 'parent', 'children', 'material', 'aabb', 'geometry'])
    const oGeoList = this.nodeInfoList_m.map(item => item.geometry)
    const geoList = await this.player.Native.PrjFunc.calcUVForGeometry(oGeoList)
    const materialParams = []
    const nodes = []
    for (let i = 0; i < this.nodeInfoList_m.length; i += 1) {
      this.nodeInfoList_m[i].originGeometry = this.nodeInfoList_m[i].geometry
      this.nodeInfoList_m[i].geometry = geoList[i]
      if (geoList[i]) {
        nodes.push(this.nodeInfoList_m[i].node)
        materialParams.push({
          node: this.nodeInfoList_m[i].node,
          props: {
            geometry: geoList[i],
          },
        })
      }
    }
    this.nodeInfoList_m = this.nodeInfoList_m.filter(item => item.geometry)
    await this.player.Native.Node.removeFromFactory(nodes)
    await this.player.Native.Node.setProperty(materialParams)
    await this.player.Native.Node.addToFactory(nodes)
    // 停顿1s
    // await new Promise(resolve => setTimeout(resolve, 1000))

    if (flag) {
      await this.addUVAnimation(newNodeInfoList)
    } else {
      const key = baseData.materialType + (baseData.direction ? '_1_' : '_0_') + baseData.flowValue
      this.materialMap[key] = new Promise(async (resolve) => {
        const imgSrc = this.formImg({}, baseData)
        const texture = await this.player.Native.Texture.create(imgSrc)

        this.textureMap[imgSrc] = texture
        const options = {
          // alpha: 0.8,
          TEX_ALBEDO: texture
        }
        const mat = await this.createMaterial(options)


        await this.player.Native.Node.setProperty(nodes, { material: mat })

        const options2 = {
          key,
          flowValue: baseData.flowValue || 5,
          direction: true,
          materialType: baseData.materialType,
          material: mat,
          imgSrc,
          texture,
          node: nodes[0],
        }
        resolve(this.createUVAnimation(options2))
      })
    }
  }

  async addUVAnimation(nodeInfoList) {
    const params = []
    await nodeInfoList.forEach(async nodeInfo => {
      if (nodeInfo.activate) {
        const key = nodeInfo.materialType + (nodeInfo.direction ? '_1_' : '_0_') + nodeInfo.flowValue
        if (this.materialMap[key]) {
          const obj = await this.materialMap[key]
          const mat = obj.material
          // params.push({node:nodeInfo.node,props:{ material: mat }})
          await this.player.Native.Node.setProperty(nodeInfo.node, { material: mat })
        } else {
          this.materialMap[key] = new Promise(async (resolve) => {
            const imgSrc = this.formImg(nodeInfo, nodeInfo)
            this.textureMap[imgSrc] = await this.player.Native.Texture.create(imgSrc)

            const options = {
              TEX_ALBEDO: this.textureMap[imgSrc],
            }
            const mat = await this.createMaterial(options)

            await this.player.Native.Node.setProperty(nodeInfo.node, { material: mat })
            const options2 = {
              key,
              flowValue: nodeInfo.flowValue || 5,
              direction: nodeInfo.direction,
              materialType: nodeInfo.materialType,
              material: mat,
              imgSrc,
              texture: this.textureMap[imgSrc],
              node: nodeInfo.node,
            }

            resolve(this.createUVAnimation(options2))
          })
        }
      } else {
        // params.push({node:nodeInfo.node,props:{ material: nodeInfo.material,geometry:nodeInfo.originGeometry }})
        await this.player.Native.Node.setProperty(nodeInfo.node, { material: nodeInfo.material })
      }
    })
    // console.log('params :>> ', params)
    // await this.player.Native.Node.setProperty(params)
  }
  //
  async createUVAnimation(options) {
    let pathList = []
    // 创建路径动画混合器

    const mixer = await this.player.Native.AnimationMixer.getMixer('pipe')
    const clip = await this.player.Native.AnimationClip.getClip(mixer, options.key)
    const action = await this.player.Native.AnimationAction.clipAction(mixer, clip)

    // 创建关键帧轨道
    const trackC = await this.player.Native.KeyframeTrack.addTrackWithParam(clip, options.node, {
      name: 'trackMat',
      trackType: 2,
      propertyLinkType: 6,
    })
    await this.player.Native.KeyframeTrack.keyClear(trackC)

    if (options.direction) {
      pathList = [
        { keyframeTrack: trackC, time: 0, value: [0, 0] },
        { keyframeTrack: trackC, time: 10 / options.flowValue, value: [1, 0] }
      ]
    } else {
      pathList = [
        { keyframeTrack: trackC, time: 0, value: [1, 0] },
        { keyframeTrack: trackC, time: 10 / options.flowValue, value: [0, 0] }
      ]
    }
    await this.player.Native.KeyframeTrack.batchKeyAppend(pathList)

    // 获取动画片段控制器
    // 绑定动画片段更新通知
    // this.player.Native.AnimationAction.bindActionUpdate(action)
    // 设置为循环模式播放
    this.player.Native.AnimationAction.setLoop(action, 1, -1)
    this.player.Native.AnimationAction.play(action)

    return {
      ...options,
      mixer,
      clip,
      action,
      KeyframeTrack: trackC,
      KeyframeTrackList: pathList
    }
  }
  // 创建材质
  async createMaterial(options) {
    const mat = await this.player.Native.Material.create(1)
    await this.player.Native.Material.setProperty(mat, options)
    return mat
  }

  // 获取图片src
  formImg(nodeInfo, baseData) {
    let res = ''
    let str = ''
    if (baseData.direction) {
      str = 'l'
    } else {
      str = 'r'
    }
    if (baseData.materialType) { // 有新属性的时候
      if (nodeInfo.size) {
        res = `${baseData.img + baseData.materialType}/${nodeInfo.size}-${baseData.materialType}-${str}.png`
      } else {
        res = `${baseData.img}${str}-${baseData.materialType}.png`
      }
    } else { // 兼容旧的属性
      res = `${baseData.img + baseData.materialType}`
    }
    return res
  }
  // 递归遍历节点
  async traverseNode(nodes, call = () => { }, keys = ['name', 'code', 'parent', 'children', 'material']) {
    if (!keys.includes('children')) {
      keys.push('children')
    }
    if (typeof nodes === 'number') {
      nodes = [nodes]
    }
    let parent
    let nodeTree
    const getChildNode = async (nodes) => {
      let data = await this.player.Native?.Node.getProperty(nodes, keys)
      data = data.filter(item => item.children)
      if (parent) {
        let index = 0
        let len
        parent.forEach((item) => {
          len = item.children.length
          item.children = data.slice(index, index + len)
          index += len
        })
      } else {
        nodeTree = data
      }
      const childNodes = []
      for (const node of data) {
        call(node)
        if (node.children?.length) {
          childNodes.push(...node.children.map(item => item.node));
        }
      }
      if (childNodes.length) {
        parent = data
        await getChildNode(childNodes)
      }
    };
    await getChildNode(nodes)

    return nodeTree
  };
  async clear() {
    // const textures = Object.values(this.textureMap)
    // const materials = Object.values(this.materialMap)
    // await this.player.Native.Texture.destroy(textures)
    this
    MaterialMap = {}
    TextureMap = {}
  }
  // 恢复
  async restore() {
    this.nodeInfoList_m = []
    this.player.Native.Node.setProperty(this.OriginNode, { visible: true })
    await this.player.Native.Node.destroy(this.cloneNode)
  }
}

export default UVAnimation
